<template>
  <div class="preview-wrap">
    <c-preview
      v-if="isPreview"
      :id="documentId"
      :subfix="subfix"
      :file="file"
    >
    </c-preview>
    <p v-else>
      {{ errText }}
    </p>
  </div>
</template>

<script>
import CPreview from './components/CPreview';
import previewMixin from './mixins/previewMixin'

export default {
  mixins: [previewMixin],
  components: {
    CPreview
  },
  data() {
    return {
      documentId: '',
      subfix: '',
      type: 1,
      file: null,
      isPreview: false,
      errText: '加载中...'
    }
  },
  created() {
    if (this.$route.params.from === 'ty') {
      let platformcode = this.$route.query.platformcode;
      let platName = '';
      if (platformcode === '999999') {
        platName = '天喻'
      }
      else if (platformcode === '411325') {
        platName = '内乡县'
        this.setIcon('https://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/favicon/nx.ico');
      }
      document.title = platName + '教育资源公共服务平台';
      document.getElementsByTagName("title")[0].innerText = platName + '教育资源公共服务平台';
      document.getElementsByName('keywords')[0].content = platName + '教育资源公共服务平台'
      document.getElementsByName('description')[0].content = platName + '教育资源公共服务平台'
    }

    this.documentId = this.$route.params.documentId;
    this.subfix = this.$route.params.subfix;
    this.type = this.$route.params.type;
  },
  mounted () {
    let {
      platformcode,
      ticket
    } = this.$route.query;
    if (!ticket || !platformcode) {
      this.errText = 'tickct 和 platformcode 不能为空';
      return;
    }
    let url = '';
    let params = {}
    if (+this.type === 2) { //  2 是备课
      url = '/api/v1/invoke/document/preview'
      params = {
        documentId: this.documentId,
        noToLogin: true
      }
    }
    else if (+this.type === 1) { // 1 是试卷
      url = '/api/v1/invoke/paper/preview'
      params = {
        paperId: this.documentId,
        noToLogin: true
      }
    }
    this.sendDevRequest(url, params).then(res => {
      this.file = res;
      this.isPreview = true;
      this.tokenRes = ''
    }).catch(err => {
      this.retryQeq(this.type, this.documentId)
      // this.isPreview = false;
      // this.errText = err.msg;
    })
  },
  methods: {
    // 尝试换着发请求
    retryQeq(type, documentId) {
      let url;
      let params
      if (+type === 1) { //  如果试卷请求不到就请求备课
        url = '/api/v1/invoke/document/preview'
        params = {
          documentId: documentId,
          noToLogin: true
        }
      }
      else if (+type === 2) { // 如果备课请求不到就请求试卷
        url = '/api/v1/invoke/paper/preview'
        params = {
          paperId: documentId,
          noToLogin: true
        }
      }
      this.sendDevRequest(url, params).then(res => {
        this.file = res;
        this.isPreview = true;
        this.tokenRes = ''
      }).catch(err => {
        this.isPreview = false;
        this.errText = err.msg;
        this.tokenRes = ''
      })
    },
    setIcon(url) {
      let faviconurl = url;
      let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = faviconurl;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  },
}
</script>

<style lang="scss" scoped>
.preview-wrap {
  width: 1000px;
  margin: 0 auto;

  p {
    text-align: center;
    margin-top: 300px;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/preview/index.vue